import { TableViewStore, BaseListViewStore, BasicQueryCheckboxStore } from 'core/stores';
import { CorporateService } from 'application/corporate/services';
import { resolveColumns } from 'application/facility/util/resolveColumns';
import { GridBooleanCell } from 'core/components';
import _ from 'lodash';
import { observable, action } from 'mobx';
import applicationContext from 'core/utils/applicationContext';

@applicationContext
class NikoCorporateListViewStore extends BaseListViewStore {
    @observable accessor downloadContactsUrl = null;
    constructor(rootStore) {
        const corporateService = new CorporateService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'nikoCorporate',
            routes: {
                create: () => {
                    return this.rootStore.routerStore.goTo(
                        'master.app.main.corporate.create',
                        {},
                        { isNiko: true }
                    )
                },
                edit: item => {
                    this.setChildNavigationTitle(i => i.id === item.id, () => item.name);
                    return this.rootStore.routerStore.goTo(
                        'master.app.main.corporate.edit',
                        { id: item.id },
                        { isNiko: true }
                    )
                },
                preview: item => {
                    this.setChildNavigationTitle(i => i.id === item.id, () => item.name)
                    return this.rootStore.routerStore.goTo(
                        'master.app.main.corporate.preview',
                        { id: item.id },
                        { isNiko: true }
                    )
                },
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const parameters = _.clone(params);
                        parameters.isActive = params.isActive ? null : true;
                        parameters.isNiko = true;
                        parameters.embed = 'ReportingIntervalType';
                        const response = await corporateService.find(parameters);
                        _.extend(response.data,
                            {
                                item: _.map(response.data.item, (item => {
                                    return _.extend(
                                        item, {
                                            reportingIntervalType: item.reportingIntervalType ? item.reportingIntervalType.name : '',
                                        }
                                    );
                                }))
                            });
                        this.onFindSuccess();
                        return response.data;
                    },
                    delete: async (item) => {
                        await corporateService.delete(item);
                    }
                }
            },
            authorization: {
                create: 'portalSection.create',
                delete: 'portalSection.delete',
            }
        });
        this.service = corporateService;
        this.queryUtility.onResetFilter = () => {
            this.basicQueryCheckboxStore.reset();
        }
        this.basicQueryCheckboxStore = new BasicQueryCheckboxStore();
        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                {
                    key: 'name',
                    title: 'CORPORATE.LIST.COLUMNS.NAME',
                    onClick: item => this.routes.preview(item)
                },
                {
                    key: 'specialOrders',
                    title: 'CORPORATE.LIST.COLUMNS.SPECIAL_ORDERS',
                    onClick: item => this.routes.preview(item),
                    cell: GridBooleanCell,
                    width: 250,
                    headerClassName: "center"
                },
                {
                    key: 'requiredSecondPayor',
                    title: 'CORPORATE.LIST.COLUMNS.REQUIRED_SECOND_PAYOR',
                    cell: GridBooleanCell
                },
                {
                    key: 'reportingIntervalType',
                    title: 'CORPORATE.LIST.COLUMNS.REPORTING_INTERVAL_TYPE'
                },
                {
                    key: 'isActive',
                    title: 'CORPORATE.LIST.COLUMNS.ISACTIVE',
                    cell: GridBooleanCell,
                    width: 100,
                    headerClassName: "center"
                }
            ]),
            actions: {
                onEdit: async (item) => this.routes.edit(item),
                onPreview: (item) => this.routes.preview(item),
            }
        }));
    }

    @action.bound
    onFindSuccess() {
        const parameters = this.queryUtility.plainFilter;
        parameters.isActive = this.queryUtility.filter.isActive ? null : true;
        parameters.isNiko = true;
        this.downloadContactsUrl =
        `${this.service.getDownloadContactsUrl(parameters)}&contentDisposition=attachment&token=${
            this.rootStore.authStore.token.tokenUrl
        }&ttype=${
            this.rootStore.authStore.token.type}`
    }

}

export default NikoCorporateListViewStore;
